import useUserSession from './useUserSession';
import { checkUserRole } from 'components/ProtectedComponent';

const usePermittedSessionPreferences = (organizationId: string) => {
  const { data: userSession } = useUserSession();

  const sessionPreferences = userSession?.session.sessionPreferences;
  const organization = userSession?.session.managedOrganizations?.find(org => org.id === organizationId);
  const hasPermission = checkUserRole('MANAGE_IN_PERSON_PAYMENTS', organization?.currentUserRole);
  const hasInPersonPaymentsPermission = Boolean(hasPermission && organization?.hasPaymentTerminals);

  return {
    canAcceptInPersonPayments: Boolean(hasInPersonPaymentsPermission && sessionPreferences?.acceptInPersonPayments),
    acceptInPersonPayments: !!sessionPreferences?.acceptInPersonPayments,
    hasInPersonPaymentsPermission,
    acceptCashAndCheckPayments: !!sessionPreferences?.acceptCashAndCheckPayments,
  };
};

export default usePermittedSessionPreferences;
